const TERM_CONDITION_QUERY_KEY = 'term-condition';

export { TERM_CONDITION_QUERY_KEY };
